import type { ReactNode } from "react";

/** A text longer than this many lines folds to its first line (Johannes, 4 Nov 11:56: "better collapsable"). */
const FOLD_AFTER_LINES = 3;

/** A long text in the log folds to its first line, the rest one click away, as the step's other details do; a short one shows whole. */
export default function LongTextFold({ text, show }: { text: string; show: (text: string) => ReactNode }) {
  const [first = "", ...rest] = text.trim().split("\n");
  if (rest.length < FOLD_AFTER_LINES) return show(text);
  return (
    <details>
      <summary className="cursor-pointer text-xs">{first.replace(/^#+\s*/u, "")}</summary>
      {show(rest.join("\n"))}
    </details>
  );
}
